import { render } from "./MainNavbar.vue?vue&type=template&id=cdef10a8&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=cdef10a8&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdef10a8"]])

export default __exports__